import { Component, inject, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CampaignHashtag } from '@infrab4a/connect';
import { ConfirmationService, PrimeIcons } from 'primeng/api';
import {
  TableActionButton,
  TableColumn,
  TableComponent
} from 'src/app/components/table';
import { CampaignHashtagService } from 'src/app/connect-api/api/shop/campaign-hashtag.service';
import { AppDialogService } from 'src/app/services/dialog.service';
import { LoaderService } from 'src/app/services/loader.service';

@Component({
  selector: 'app-glam-campaigns',
  templateUrl: './glam-campaigns.component.html',
  styleUrls: ['./glam-campaigns.component.scss']
})
export class GlamCampaignsComponent {
  @ViewChild(TableComponent) table: TableComponent;

  protected campaignHashtagService = inject(CampaignHashtagService);
  private confirmationService = inject(ConfirmationService);
  private title = inject(Title);

  protected cols = [
    new TableColumn.Builder()
      .setHeader('Título')
      .setField('title')
      .setType('text')
      .setCondition('contains')
      .setRouterLink('/configuracoes/glam/campaigns/')
      .setRouterLinkFieldName('id')
      .build(),
    new TableColumn.Builder()
      .setHeader('Hashtag')
      .setField('hashtagCode')
      .setType('text')
      .setCondition('contains')
      .build(),
    new TableColumn.Builder()
      .setHeader('Glampoints mín.')
      .setField('minimumGlampoints')
      .setType('number')
      .build(),
    new TableColumn.Builder()
      .setHeader('Glampoints máx.')
      .setField('maximumGlampoints')
      .setType('number')
      .build(),
    new TableColumn.Builder()
      .setHeader('Início')
      .setField('startDate')
      .setType('date')
      .setCondition('gte')
      .build(),
    new TableColumn.Builder()
      .setHeader('Término')
      .setField('endDate')
      .setType('date')
      .setCondition('lte')
      .build(),
    new TableColumn.Builder()
      .setHeader('Ativa')
      .setField('active')
      .setType('inputSwitch')
      .setCondition('equals')
      .build(),
    new TableColumn('Ação', '', false, 'button')
  ];

  protected actionButtons = [
    new TableActionButton(
      '',
      'Excluir',
      PrimeIcons.TRASH,
      undefined,
      '',
      'Excluir',
      'bottom',
      true,
      true,
      'danger',
      'small'
    )
  ];

  protected dropdownFilters = {
    active: [
      { label: 'Todas', value: undefined },
      { label: 'Ativa', value: true },
      { label: 'Inativa', value: false }
    ]
  };

  constructor() {
    this.title.setTitle('Campanhas');
  }

  async buttonClick(event: { item: { id: string }; $event: Event }) {
    this.confirmationService.confirm({
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      message: 'Tem certeza que deseja excluir a campanha?',
      target: event.$event?.target,
      acceptButtonStyleClass: 'p-button-danger',
      accept: async () => {
        LoaderService.showLoader();
        try {
          await this.campaignHashtagService.deleteCampaign(event.item.id);
        } catch (error) {
          AppDialogService.showErrorDialog(error);
        } finally {
          await this.table.refresh();
          LoaderService.showLoader(false);
        }
      }
    });
  }

  async updateActive(campaign: Partial<CampaignHashtag>) {
    LoaderService.showLoader();
    try {
      await this.campaignHashtagService.updateCampaign({
        id: campaign.id,
        active: campaign.active
      });
    } catch (error) {
      AppDialogService.showErrorDialog(error);
    } finally {
      await this.table.refresh();
      LoaderService.showLoader(false);
    }
  }
}
